import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
import {
    SET_TOGGLE
} from '@/store/mutations.type'
Vue.use(VueRouter)

const ifNotAuthenticated = (to, from, next) => {
    if (!store.getters.isAuthenticated) {
        next()
        return
    }
    next('/')
}

const ifAuthenticated = (to, from, next) => {
    if (store.getters.isAuthenticated) {
        next()
        return
    }
    // Controllo se l'utente arriva dal link della mail;
    let _next = {
        path: '/login'
    }
    let queryString = null
    let url = document.URL
    if (url.includes('survey')) {
        queryString = url ? url.split('?')[1] : ''
        _next.query = {
            surveyParams: queryString
        }
    }
    next(_next)
}

const routes = [
    {
        path: '/',
        // redirect: '/projects',
        name: 'home',
        beforeEnter: ifAuthenticated,
        component: () => import('@/views/pages/Home.vue'),
        meta: {
            breadcrumb: [
                {
                    name: 'Home'
                }
            ]
        }
    },
    {
        path: '/login',
        name: 'login',
        beforeEnter: ifNotAuthenticated,
        component: () => import('@/views/pages/Login.vue')
    },
    {
        path: '/verify-login/:token',
        name: 'verify-login',
        component: () => import('@/views/pages/VerifyLogin.vue')
    },
    {
        path: '/404',
        name: '404',
        component: () => import('@/views/pages/404.vue')
    },
    {
        path: '/missions',
        component: () => import('@/views/projects/Projects.vue'),
        props: true,
        children: [
            {
                path: '',
                name: 'missions',
                component: () => import('@/views/projects/List.vue'),
                beforeEnter: ifAuthenticated,
                meta: {
                    breadcrumb: [{
                        name: 'Home',
                        link: '/'
                    },
                    {
                        name: 'Missioni'
                    }
                    ]
                }
            },
            {
                path: ':id',
                name: 'mission-detail',
                component: () => import('@/views/projects/Detail.vue'),
                beforeEnter: ifAuthenticated,
                meta: {
                    breadcrumb: [{
                        name: 'Home',
                        link: '/'
                    },
                    {
                        name: 'Missioni',
                        link: '/missions'
                    },
                    {
                        name: 'Tratte'
                    }
                    ]
                }
            }
        ]
    },
    {
        path: '/surveys',
        component: () => import('@/views/surveyjs/Survey.vue'),
        props: true,
        children: [
            {
                path: ':guid',
                name: 'compiler',
                beforeEnter: ifAuthenticated,
                component: () => import('@/views/surveyjs/Compiler.vue'),
                meta: {
                    breadcrumb: [
                        {
                            name: 'Home',
                            link: '/'
                        },
                        {
                            name: 'Missioni',
                            link: '/missions'
                        },
                        {
                            name: 'Tratte',
                            link: '/missions'
                        },
                        {
                            name: 'Questionario'
                        }
                    ]
                }
            }
        ]
    },
    {
        path: '/articles',
        component: () => import('@/views/articles/Articles.vue'),
        props: true,
        children: [
            {
                path: '',
                name: 'articles',
                component: () => import('@/views/articles/List.vue'),
                beforeEnter: ifAuthenticated,
                meta: {
                    breadcrumb: [{
                        name: 'Home',
                        link: '/'
                    },
                    {
                        name: 'News'
                    }
                    ]
                }
            }
        ]
    },
    {
        path: '/users',
        component: () => import('@/views/users/Users.vue'),
        props: true,
        beforeEnter: ifAuthenticated,
        children: [{
            path: '',
            name: 'users',
            component: () => import('@/views/users/List.vue'),
            beforeEnter: ifAuthenticated,
            meta: {
                breadcrumb: [{
                    name: 'Home',
                    link: '/'
                },
                {
                    name: 'Utenti'
                }
                ]
            }
        },
        {
            path: ':id',
            name: 'user-detail',
            component: () => import('@/views/users/Detail.vue'),
            beforeEnter: ifAuthenticated,
            meta: {
                breadcrumb: [{
                    name: 'Home',
                    link: '/'
                },
                // {
                //     name: 'Utenti',
                //     link: '/users'
                // },
                {
                    name: 'Dettaglio utente'
                }
                ]
            }
        }
        ]
    },
    {
        path: '/documents',
        beforeEnter: ifAuthenticated,
        component: () => import('@/views/documents/Documents.vue'),
        children: [{
            path: '',
            name: 'documents',
            component: () => import('@/views/documents/List.vue'),
            beforeEnter: ifAuthenticated,
            meta: {
                breadcrumb: [{
                    name: 'Home',
                    link: '/'
                },
                {
                    name: 'Documenti'
                }
                ]
            }
        }]
    },
    {
        path: '/messages',
        beforeEnter: ifAuthenticated,
        component: () => import('@/views/messages/Messages.vue'),
        children: [{
            path: '',
            name: 'messages',
            component: () => import('@/views/messages/List.vue'),
            beforeEnter: ifAuthenticated,
            meta: {
                breadcrumb: [{
                    name: 'Home',
                    link: '/'
                },
                {
                    name: 'Messaggi'
                }
                ]
            }
        },
        {
            path: ':id',
            name: 'message-detail',
            component: () => import('@/views/messages/Detail.vue'),
            beforeEnter: ifAuthenticated,
            meta: {
                breadcrumb: [{
                    name: 'Home',
                    link: '/'
                },
                {
                    name: 'Messaggi',
                    link: '/messages'
                },
                {
                    name: 'Dettaglio messaggio'
                }
                ]
            }
        }
        ]
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

// Chiudo sempre il menu laterale (mobile) al cambio pagina
router.afterEach(() => {
    store.commit(SET_TOGGLE, true)
})

export default router
